import React from 'react';
import PropTypes from "prop-types";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { lighten, makeStyles } from "@material-ui/core/styles";
import { Toolbar, Typography, Button } from '@material-ui/core';
import { validarSoloUnPermiso } from '../../../helpers/permisos';
import { TURNOS_PERMISOS } from '../../../utils/permisos';

const useToolbarStyles = makeStyles((theme) => ({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      marginTop: 20,
    },
    highlight:
      theme.palette.type === "light"
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85),
          }
        : {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.dark,
          },
    title: {
      flex: "1 1 100%",
    },
    formControl: {
    //   margin: theme.spacing(1),
      marginLeft: 20,
      marginRight: 20,
      minWidth: 250,
    },
    button: {
      width: 200,  
    },
}));

export const TableToolbarBajaMasiva = (props) => {
    const classes = useToolbarStyles();
    const { numSelected } = props;
    const { permisos: permisosUser } = useSelector(state => state.auth)

    /* const handleUpdate = () => {
        dispatch( updateCandidatosBaja( props.idTipo ) );
    } */
  
    return (
      <Toolbar
        className={clsx(classes.root, {
          [classes.highlight]: numSelected > 0,
        })}
      >
        {numSelected > 0 ? (
          <Typography
            className={classes.title}
            color="inherit"
            variant="subtitle1"
            component="div"
          >
            {numSelected !== 1
              ? `${numSelected.toLocaleString()} registros seleccionados`
              : `${numSelected.toLocaleString()} registro seleccionado`
            }
          </Typography>
        ) : (
          null
        )}
        {numSelected > 0 ? (
          <Button 
              variant="contained" 
              color="primary" 
              className={classes.button}
              onClick={props.handleSubmit}
              disabled={!validarSoloUnPermiso(permisosUser, TURNOS_PERMISOS.BAJA)}
          >
              Bajas Masivas
          </Button>
        ) : null}
      </Toolbar>
    );
  };
  
  TableToolbarBajaMasiva.propTypes = {
    numSelected: PropTypes.number.isRequired,
  };